import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';

import withRoot from '@arcblock/www/src/components/withRoot';

import PageContent from '../components/post/content';
import PageHeader from '../components/post/header';
import PageFooter from '../components/post/footer';

import ContentWrapper from '../components/wrapper/content';
import Layout, { themeConfig } from '../components/layout';
import renderAst from '../components/renderAst';

function PageDocumentation(props) {
  const { hash, pathname } = props.location;
  const { file } = props.data;
  const { frontmatter, headings } = file.childMarkdownRemark || file.childMdx;
  const { sidebarContent, locale, githubUrl, communityPath, navItems, version } = props.pageContext;

  const pages = sidebarContent
    .reduce((acc, { pages: pageList, url, title }) => acc.concat([{ path: url, title }]).concat(pageList), [])
    .filter(page => !page.anchor);

  return (
    <Layout
      locale={locale}
      title={frontmatter.title}
      description={frontmatter.description}
      location={props.location}
      version={version}
      sidebarContent={sidebarContent}
      navItems={navItems}>
      {({ mainRef }) => (
        <Main>
          <PageHeader {...frontmatter} />
          <PageContent
            title={frontmatter.title}
            pathname={pathname}
            pages={pages}
            headings={props.pageContext.headings || headings}
            hash={hash}
            githubUrl={githubUrl}
            communityPath={communityPath}
            mainRef={mainRef}>
            {renderAst(file.childMarkdownRemark.htmlAst)}
          </PageContent>
          <PageFooter changeTime={file.changeTime} />
        </Main>
      )}
    </Layout>
  );
}

PageDocumentation.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRoot(themeConfig)(PageDocumentation);

export const pageQuery = graphql`
  query DocumentationQuery($id: String) {
    file(id: { eq: $id }) {
      changeTime(fromNow: true)
      childMarkdownRemark {
        frontmatter {
          author
          category
          date
          description
          draft
          keywords
          language
          layout
          path
          tags
          title
        }
        htmlAst
      }
    }
  }
`;

const Main = styled(ContentWrapper)`
  padding-bottom: 0;
`;
